import React, { useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Alert, Button, Card, Col, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
//api
import { changePassword } from './ProfileSlice';
const ChangePwdSchema = yup.object().shape({
  oldPwd: yup
    .string()
    .required('Old Password is a required field.')
    .min(8, 'Password must be at least 8 characters.'),
  newPwd: yup
    .string()
    .notOneOf(
      [yup.ref('oldPwd')],
      'Old Password and New Password cannot be the same.'
    )
    .required('New Password is a required field.')
    .min(8, 'Password must be at least 8 characters.'),
  confirmPwd: yup
    .string()
    .oneOf([yup.ref('newPwd')], 'Passwords must match.')
    .required('Confirm Password is a required field.')
    .min(8, 'Password must be at least 8 characters.'),
});
const ChangePassword = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const dispatch = useDispatch();
  const [oldPwdShown, setOldPwdShown] = useState(false);
  const [newPwdShown, setNewPwdShown] = useState(false);
  const [confirmPwdShown, setConfirmPwdShown] = useState(false);

  const {
    register,
    getValues,
    resetField,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(ChangePwdSchema),
  });

  const handleSubmitChangePassword = () => {
    const oldPassword = getValues('oldPwd');
    const newPassword = getValues('newPwd');
    const confirmPassword = getValues('confirmPwd');
    if (newPassword === confirmPassword) {
      dispatch(changePassword({ oldPassword, confirmPassword, token }));
    }
    resetField('oldPwd');
    resetField('newPwd');
    resetField('confirmPwd');
  };
  // edit
  return (
    <Col sm={6}>
      <Card>
        <Card.Header>
          <h5>{t('change-password')}</h5>
        </Card.Header>
        <Card.Body>
          <form
            id="changePassword"
            action="/changePassword"
            method="post"
            onSubmit={handleSubmit(handleSubmitChangePassword)}
          >
            <Form.Group>
              <Form.Label>{t('old-password')}:</Form.Label>
              <div className="input-group">
                <input
                  type={oldPwdShown ? 'text' : 'password'}
                  name="pw"
                  className="form-control"
                  id="pw"
                  {...register('oldPwd')}
                />
                <i
                  className={
                    !oldPwdShown ? 'feather icon-eye-off' : 'feather icon-eye'
                  }
                  onClick={() => {
                    setOldPwdShown(!oldPwdShown);
                  }}
                ></i>
              </div>
              {errors.oldPwd && (
                <Alert
                  variant="danger"
                  style={{
                    padding: '5px',
                    height: '32px',
                  }}
                >
                  <p>{errors.oldPwd.message}</p>
                </Alert>
              )}
            </Form.Group>

            <Form.Group>
              <Form.Label>{t('new-password')}:</Form.Label>
              <div className="input-group">
                <input
                  type={newPwdShown ? 'text' : 'password'}
                  name="newpw1"
                  className="form-control"
                  id="newpw1"
                  {...register('newPwd')}
                />
                <i
                  className={
                    !newPwdShown ? 'feather icon-eye-off' : 'feather icon-eye'
                  }
                  onClick={() => {
                    setNewPwdShown(!newPwdShown);
                  }}
                ></i>
              </div>
              {errors.newPwd && (
                <Alert
                  variant="danger"
                  style={{
                    padding: '5px',
                    height: '32px',
                  }}
                >
                  <p>{errors.newPwd.message}</p>
                </Alert>
              )}
            </Form.Group>

            <Form.Group>
              <Form.Label>{t('confirm-password')}:</Form.Label>
              <div className="input-group">
                <input
                  type={confirmPwdShown ? 'text' : 'password'}
                  name="newpw2"
                  className="form-control"
                  id="newpw2"
                  {...register('confirmPwd')}
                />
                <i
                  className={
                    !confirmPwdShown
                      ? 'feather icon-eye-off'
                      : 'feather icon-eye'
                  }
                  onClick={() => {
                    setConfirmPwdShown(!confirmPwdShown);
                  }}
                ></i>
              </div>
              {errors.confirmPwd && (
                <Alert
                  variant="danger"
                  style={{
                    padding: '5px',
                    height: '32px',
                  }}
                >
                  <p>{errors.confirmPwd.message}</p>
                </Alert>
              )}
            </Form.Group>
            <Button
              style={{ marginTop: '12px' }}
              type="submit"
              className="btn btn-primary"
            >
              {t('change')}
            </Button>
          </form>
        </Card.Body>
      </Card>
    </Col>
  );
};
export default ChangePassword;
